import {useDispatch} from 'react-redux';
import AnchorCardV4 from '../../common/component/AnchorCardV4';
import LabelBadgeV4 from '../../common/component/LabelBadgeV4';
import {Page} from '../../common/constant/page';
import FetchList from '../../common/container/FetchList';
import {PageInfo, routeTo} from '../../common/util/PageRouter';
import MaxWidth from '../../commonSub/component/MaxWidth';
import {sendSearchEventV4} from '../common';
import {actions, ActionType} from '../state/action';
import {ISearchResult, ISearchType} from '../type';

interface IProps {
  result: ISearchResult;
  keyword: string;
  type: ISearchType;
}

export default function ResultV4({result, keyword, type}: IProps) {
  const dispatch = useDispatch();
  const {contents, totalCount} = result;

  return (
    <MaxWidth className="pt-64 px-11 pb-20">
      <FetchList
        items={contents}
        fetchKey={type}
        itemClassName="mt-4"
        actionType={ActionType.FetchResult}
        requestGetNextList={() => {
          dispatch(actions.fetchResult({keyword, type}));
        }}
      >
        {idx => {
          const {
            id,
            sid,
            badges,
            bgImg,
            mainImg,
            title,
            mainTitleImg,
            authors,
            genre,
          } = contents[idx];

          const pageInfo: PageInfo = {page: Page.Content, id, sid};

          return (
            <AnchorCardV4
              key={id}
              content={{
                id,
                sid,
                badges,
                bgImg,
                mainImg,
                title,
                mainTitleImg,
              }}
              labelBadgeElement={
                <LabelBadgeV4
                  label={{
                    text: `#${genre}`,
                    bgColor: 'black',
                  }}
                />
              }
              pageInfo={pageInfo}
              blackMaskOpacity="50%"
              desc={authors}
              onClick={() => {
                sendSearchEventV4({
                  viewType: 'resultView',
                  actionName: 'content',
                  customProps: {
                    content_id: id,
                    event_layer: 'search_result',
                    ordnum: idx + 1,
                    search_keyword: keyword,
                    search_result_count: totalCount,
                  },
                });
                routeTo(pageInfo);
              }}
            />
          );
        }}
      </FetchList>
    </MaxWidth>
  );
}
